import ActionItemDelete from "../../../cm/Dashboard/FullPages/ActionItems/Modals/ActionItemDelete";
import ActionItemDetail from "../../../cm/Dashboard/FullPages/ActionItems/Modals/ActionItemDetail";
import ResponseModal from "../../../global/ResponseModal";
import AddActionItemModal from "../../FollowUps/ActionableItems/AddActionItemModal";
import { STRINGS } from "../utils/strings";

export default function ActionItemModals({
  isActionItemModalOpen,
  setIsActionItemModalOpen,
  activeActionItem,
  setActiveActionItem,
  caseObj,
  onSuccess,
  deleteOpen,
  setDeleteOpen,
  detailOpen,
  setDetailOpen,
  onNavigateToClient,
  openSuccess,
  setOpenSuccess,
  openError,
  setOpenError,
  errorMessage,
}) {
  return (
    <>
      {isActionItemModalOpen && (
        <AddActionItemModal
          addOpen={isActionItemModalOpen}
          setAddOpen={setIsActionItemModalOpen}
          activeActionItem={activeActionItem}
          setActiveActionItem={setActiveActionItem}
          caseObj={caseObj}
          onSuccess={onSuccess}
        />
      )}

      {deleteOpen && (
        <ActionItemDelete
          deleteOpen={deleteOpen}
          setDeleteOpen={setDeleteOpen}
          setActiveActionItem={setActiveActionItem}
          activeActionItem={activeActionItem}
          onSuccess={onSuccess}
        />
      )}

      {detailOpen && (
        <ActionItemDetail
          detailOpen={detailOpen}
          setDetailOpen={setDetailOpen}
          setActiveActionItem={setActiveActionItem}
          activeActionItem={activeActionItem}
          navigateToDetail={onNavigateToClient}
        />
      )}

      <ResponseModal
        title={STRINGS.MODAL_SUCCESS_TITLE}
        description={STRINGS.MODAL_SUCCESS_DESCRIPTION}
        openBool={openSuccess}
        setOpenBool={setOpenSuccess}
        handleCloseFunc={() => setOpenSuccess(false)}
      />

      <ResponseModal
        title={STRINGS.MODAL_ERROR_TITLE}
        isError={true}
        openBool={openError}
        setOpenBool={setOpenError}
        errorMessage={errorMessage}
      />
    </>
  );
}
